import ajax from '../util/ajax';

/**
 * 中国在各领域与他国合著论文数量
 */
export function paperPublishCount() {
    return ajax({
        url: '/scimallH5/Dxsv2xshujl/paperPublishCount'
    });
}


/**
 * 中国在各领域与他国合著论文影响力
 */
export function paperInfluence() {
    return ajax({
        url: '/scimallH5/Dxsv2xshujl/paperInfluence'
    });
}


/**
 * 中国与他国合著论文数量
 */
export function paperCoCount(country = '日本,美国') {
    return ajax({
        url: '/scimallH5/Dxsv2xshujl/paperCoCount',
        params: {
            country: country
        }
    });
}


/**
 * 中国与他国合著论文情况
 */
export function worldPublishCount() {
    return ajax({
        url: '/scimallH5/Dxsv2xshujl/worldPublishCount'
    });
}


/**
 * 最新会议资讯
 */
export function getNewMeeting() {
    return ajax({
        url: '/scimallH5/Dxsxsjl/getNewMeeting?type=1'
    });
}


/**
 * 中国与他国合著论文影响力
 */
export function paperCoInfulence(country = '日本,美国') {
    return ajax({
        url: '/scimallH5/Dxsv2xshujl/paperCoInfulence',
        params: {
            country: country
        }
    });
}


/**
 * 各国论文中属于跨国合作的论文数量占比
 */
export function paperCoScale(country = '日本,美国') {
    return ajax({
        url: '/scimallH5/Dxsv2xshujl/paperCoScale',
        params: {
            country: country
        }
    });
}


/**
 * 各级科协学会办会场次
 */
export function meetingScene() {
    return ajax({
        url: '/scimallH5/Dxsxsjl/meetingScene?type=1'
    });
}


/**
 * 中国科协重要学术会议指南
 */
export function meetingGuide() {
    return ajax({
        url: '/scimallH5/Dxsv2xshujl/meetingGuide'
    });
}


/**
 * 科技相关的国际交流情况
 */
export function projectStatus(type) {
    return ajax({
        url: '/scimallH5/Dxsv2xshujl/projectStatus',
        params: {
            type: type
        }
    });
}

/** 中国科协重要学术会议指南 - 二级 **/


/**
 * 各领域会议数量分布
 */
export function getMeetCount() {
    return ajax({
        url: '/scimallH5/Dxsv2hyzn/getMeetCount'
    });
}

/**
 * 各领域参会人员数量
 */
export function getParticipants() {
    return ajax({
        url: '/scimallH5/Dxsv2hyzn/getParticipants'
    });
}

/**
 * 各领域会议创办至今总计届次
 */
export function getTotalSessions() {
    return ajax({
        url: '/scimallH5/Dxsv2hyzn/getTotalSessions'
    });
}

/**
 * 学术会议论文被收录的比例情况
 */
export function getIncludedProportion() {
    return ajax({
        url: '/scimallH5/Dxsv2hyzn/getIncludedProportion'
    });
}

/**
 * 会议举办时间分布
 */
export function getMeetTime() {
    return ajax({
        url: '/scimallH5/Dxsv2hyzn/getMeetTime'
    });
}

/**
 * 各领域会议举办天数
 */
export function getMeetingDays() {
    return ajax({
        url: '/scimallH5/Dxsv2hyzn/getMeetingDays'
    });
}


/**
 * 会议举办国家
 */
export function getHostCountry() {
    return ajax({
        url: '/scimallH5/Dxsv2hyzn/getHostCountry'
    });
}


/**
 * 地图
 */
export function map() {
    return ajax({
        url: '/scimallH5/Dxsv2hyzn/map'
    });
}
